import { useContext } from "react"
import { PopupContext } from "../context/Popup/PopupProvider"
const usePopup = ()=>{
   const popupContext = useContext(PopupContext)
   if (!popupContext) {
    throw new Error(
      "usePopup must be used within an PopupProvider"
    );
  }
  return popupContext
}
export default usePopup